import { setupWorker } from "msw/browser"
import { getAnalyticsMock } from "@/shared/api/generated/analytics/analytics.msw"
import { getAuthMock } from "@/shared/api/generated/auth/auth.msw"
import { getJobsMock } from "@/shared/api/generated/jobs/jobs.msw"
import { getMarketingContextMock } from "@/shared/api/generated/marketing-context/marketing-context.msw"
import { getMarketingMessagesMock } from "@/shared/api/generated/marketing-messages/marketing-messages.msw"
import { getMarketingProvidersMock } from "@/shared/api/generated/marketing-providers/marketing-providers.msw"
import { getMarketingRunsMock } from "@/shared/api/generated/marketing-runs/marketing-runs.msw"
import { getMarketingSegmentsMock } from "@/shared/api/generated/marketing-segments/marketing-segments.msw"
import { getMarketingTasksMock } from "@/shared/api/generated/marketing-tasks/marketing-tasks.msw"
import { getOAuthAPIMock } from "@/shared/api/generated/oauth/oauth-api.msw"
import { getReportsMock } from "@/shared/api/generated/reports/reports.msw"
import { getUserMock } from "@/shared/api/generated/user/user.msw"
import { env } from "../config/env"
import { getMarketingFixtureHandlers } from "./marketing-fixture-handlers"

const worker = setupWorker(
	// Stable marketing fixtures first — MSW uses the first matching handler.
	...getMarketingFixtureHandlers(),
	...getMarketingContextMock(),
	...getMarketingMessagesMock(),
	...getMarketingProvidersMock(),
	...getMarketingRunsMock(),
	...getMarketingSegmentsMock(),
	...getMarketingTasksMock(),
	...getAnalyticsMock(),
	...getJobsMock(),
	...getReportsMock(),
	...getUserMock(),
	...getAuthMock(),
	...getOAuthAPIMock(),
)

export const enableMocking = async () => {
	if (env.VITE_ENABLE_MOCK) {
		return worker.start()
	}

	return
}
